var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.242,
    height: 36.242,
    viewBox: "0 0 36.242 36.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M139.21,139.21h36.242v36.242H139.21Z",
    transform: "translate(-139.21 -139.21)",
    fill: "#2c728a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(-139.21 -139.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3166",
    "data-name": "Group 3166",
    transform: "translate(139.21 139.21)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M157.331,139.21,139.21,157.331l18.121,18.121,18.121-18.121Zm-15.558,18.121,15.558-15.558,15.558,15.558-15.558,15.558Z",
    transform: "translate(-139.21 -139.21)",
    fill: "#2c728a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M330.135,287.49l-1.246,1.316,2.893,2.74h-9.066v9.06l1.812,1.812v-9.061h7.391l-3.064,3.227,1.314,1.248,5.155-5.428Z",
    transform: "translate(-169.463 -136.932)",
    fill: "#2c728a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.eeb61ce3343ff16aec04796a1a562969.svg";
export { ForwardRef as ReactComponent };